import * as React from 'react';
export const vercelSvg = React.forwardRef(function vercelSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#000',
      style: {
        fill: 'light-dark(#000,#fff)',
      },
      d: 'm16 6.5 11 19H5l11-19Z',
    }),
  );
});
vercelSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '32',
  height: '32',
  fill: 'none',
  viewBox: '0 0 32 32',
};
export var vercel = {
  category: 'brand',
  colorable: false,
  name: 'vercel',
  svg: vercelSvg,
};
